import React from 'react';
import styled, { css } from 'styled-components';
import {baseInput, labelStyle} from '../styles/includes/forms';

const StyledComponent = styled.div`
  label {
    ${labelStyle};
  }
  input {
		${baseInput};
    padding: 0 13px !important;
    width: 100%;
  }
`

const Component = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <StyledComponent className={'field ' + (className? className : '')}>
            {(() => {
                if (props.label !== undefined) {
                    return <label htmlFor={props.name}>{props.label}</label>
                }
            })()}
            <input id={props.name} type={props.type ? props.type :'text'} {...props} ref={ref} />
        </StyledComponent>
    )
});

export default Component;
